import { IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseCommand, IBridgeIntegration } from '../../send-command-to-device';

export const DENTALEYE_INTEGRATION: IBridgeIntegration = {
  label: 'DentalEye',
  description: 'Two-way integration with DentalEye imaging software',
};

export type DentalEyeOpenPatientCommand = IBaseCommand<
  DentalEyeToDeviceCommand.OpenPatient,
  { patient: WithRef<IPatient> }
>;

export type DentalEyeAddPatientRecordCommand = IBaseCommand<
  DentalEyeToDeviceCommand.AddPatientRecord,
  { patient: WithRef<IPatient> }
>;

export enum DentalEyeToDeviceCommand {
  OpenPatient = 'dentalEye.openPatient',
  AddPatientRecord = 'dentalEye.addPatientRecord',
}
